import classNames from "classnames";
import React, { ReactNode } from "react";
import TopNav from "../TopNav/TopNav";

import { SitePage } from "../../types/SitePage";
import "./PageLayout.scss";

function mapLocationToPage(pathname: string): SitePage {
  if (pathname.startsWith("/account")) {
    return SitePage.Account;
  }
  if (pathname.startsWith("/admin")) {
    return SitePage.Admin;
  }
  if (pathname.startsWith("/podcasts")) {
    return SitePage.Podcasts;
  }
  if (pathname.startsWith("/find-vc")) {
    return SitePage.VCDirectory;
  }
  return SitePage.Unknown;
}

interface PageLayoutProps {
  children: ReactNode;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children }) => {
  const page: SitePage = mapLocationToPage(window.location.pathname);
  const pageLayoutClass = classNames("page-layout", {
    [page]: true,
  });

  return (
    <div className={pageLayoutClass}>
      <TopNav page={page} />
      <main className="page-content">{children}</main>
    </div>
  );
};

export default PageLayout;
